import { Directive, ElementRef, Renderer } from "@angular/core";

@Directive({
  selector: "[dSwitch]"
})
export class SwitchDirective {
  constructor(public renderer: Renderer, public el: ElementRef) {}
}
